import Index from '@/views/Index.vue';
import Test from '@/views/Test.vue';
import Tools from '@/views/Tools.vue';
import Cache from '@/views/Cache.vue';
import TrackAnalyze from '@/views/TrackAnalyze.vue';
import Weather from '@/views/Weather.vue';

import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/test.html',
      name: 'test',
      component: Test,
    },
    {
      path: '/cache.html',
      name: 'cache',
      component: Cache,
    },
    {
      path: '/tools.html',
      name: 'tools',
      component: Tools,
    },
    {
      path: '/trackanalyze/:id/',
      name: 'trackanalyze',
      component: TrackAnalyze,
    },
    {
      path: '/weather/',
      name: 'weather',
      component: Weather,
    },
  ],
});

export default router;